import template from './public.pug';

/* @ngInject */
export default function routes($stateProvider) {
  $stateProvider
    .state('public', {
      abstract: true,
      url: '/public',
      template,
    });
}



// WEBPACK FOOTER //
// ./client/app/public/public.routes.js